import { render, staticRenderFns } from "./mendian_xiangqing.vue?vue&type=template&id=54d76dc3&"
import script from "./mendian_xiangqing.vue?vue&type=script&lang=js&"
export * from "./mendian_xiangqing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports